<template>
  <a-row :gutter="20" class="setup-share-story">
    <a-col :class="settings.isMenuCollapsed ? 'toggled' : 'unfixed'">
      <a-spin :spinning="progress >= 0" :tip="`Uploading ${progress}%`" size="large">
        <div class="spin-content">
          <a-card :title="$t('label.inviteModerator')" class="style3 text-center">
            <div style="100%; text-align: right; padding-bottom: 16px;" v-if="!originPageVisible || videoFile">
              <a-button type="link" class="tf-primary" @click="originPageVisible = true">View Original Page</a-button>
            </div>
            <a-row v-if="originPageVisible || (!videoFile && !churchLogo)">
              <a-col :xs="{ span: 24, offset: 0 }" :sm="{ span: 20, offset: 2 }" :md="{ span: 16, offset: 4 }" :xl="{ span: 12, offset: 6 }">
                <div class="responsive-embed">
                  <iframe :src="instructionVideo('MODERATOR_RECRUITMENT')" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                </div>
                <img :src="require('../../assets/images/how_to_film.png')" />

                <div class="text-left font-helvetica">
                  <b>Script Suggestion:</b>
                  <br />
                  <p>
                    Hello friend, when I heard that TrueLife.org needed help to moderate the Jesus Stories, I really did think that you would be a perfect fit. Please watch this video about the Jesus
                    Story campaign and then follow the links to help TrueLife.org not have any bad Jesus Stories on their website. Thank you!
                  </p>
                </div>
              </a-col>
            </a-row>
            <a-row v-if="videoFile || churchLogo" :gutter="20">
              <a-col :md="{ span: 16 }" :sm="{ span: 24 }">
                <a-card hoverable v-if="videoFile">
                  <div class="player-wrapper mt-2" style="background: black">
                    <div v-if="isVideoCaptured">
                      <video class="video-js" controls preload="auto">
                        <source :src="videoFileUrl(videoFile)" type="video/webm" />
                      </video>
                    </div>
                    <div v-else id="previewSelectedVideo" />
                  </div>
                  <template slot="actions" class="ant-card-actions">
                    <a-button type="danger" class="tf-btn tf-btn-danger mt-2 px-4" @click="removeVideo()" icon="delete"> Delete </a-button>
                    <a-button type="primary" class="tf-btn tf-btn-primary mt-2 px-4" @click="saveVideo()" icon="save"> Save </a-button>
                  </template>
                </a-card>
              </a-col>

              <a-col :md="{ span: 8 }" :sm="{ span: 24 }">
                <a-card hoverable v-if="churchLogo">
                  <img slot="cover" :src="churchLogo" />
                  <template slot="actions" class="ant-card-actions">
                    <a-button type="danger" class="tf-btn tf-btn-danger mt-2 px-4" @click="removeImage()" icon="delete"> Delete </a-button>
                    <a-button type="primary" class="tf-btn tf-btn-primary mt-2 px-4" @click="saveImage()" icon="save"> Save </a-button>
                  </template>
                </a-card>
              </a-col>
            </a-row>

            <div class="mt-4">
              <div class="link-label font-helvetica">{{ $t('label.moderatorInvitationLink') }}</div>
              <div class="link-value mt-2">
                <a :href="pageUrl" target="_blank">{{ pageUrl }}</a>
                <a-button type="primary" class="tf-btn tf-btn-primary clipboard-btn" v-clipboard:copy="pageUrl" v-clipboard:success="clipboardSuccess">
                  <inline-svg :src="require('../../assets/images/clipboard.svg')" width="12" height="14" />
                </a-button>
              </div>
            </div>

            <a-row :gutter="20" class="mt-5">
              <a-col :md="{ span: 16 }" :sm="{ span: 24 }">
                <a-row>
                  <a-col :md="{ span: 12 }" :sm="{ span: 24 }">
                    <a-button type="primary" class="tf-btn tf-btn-primary mb-4" @click="e => $refs.videoPicker.click()"> <a-icon type="upload" />Upload Pastor Moderator Video </a-button>
                    <input type="file" style="width: 0; height: 0" accept="video/mp4,video/x-m4v,video/*" ref="videoPicker" @change="videoSelectChange" />
                  </a-col>
                  <a-col :md="{ span: 12 }" :sm="{ span: 24 }">
                    <a-button type="primary" class="tf-btn tf-btn-primary mb-4" @click="captureVideo">
                      <inline-svg :src="require('../../assets/images/record-video.svg')" width="18" height="12" />
                      <span style="margin-left: 4px">Capture Pastor Moderator Video</span>
                    </a-button>
                  </a-col>
                </a-row>
              </a-col>
              <a-col :md="{ span: 8 }" :sm="{ span: 24 }">
                <a-button type="primary" class="tf-btn tf-btn-primary mb-4" @click="e => $refs.imagePicker.click()"> <a-icon type="upload" />Upload Church Moderator Logo </a-button>
                <input type="file" style="width: 0; height: 0" accept="image/png" ref="imagePicker" @change="imageSelectChange" />
              </a-col>
            </a-row>
          </a-card>
        </div>
      </a-spin>
    </a-col>
  </a-row>
</template>
<script>
import { mapState } from 'vuex';
import store from '@/store';
import Constants from '@/constants.js';
import Uploader from '@/services/UploadService';
import AdminService from '@/services/AdminService';
export default {
  data() {
    return {
      selectedVideo: null,
      isVideoCaptured: false,
      selectedLogo: null,
      progress: -1,
      originPageVisible: true,
    };
  },
  computed: {
    ...mapState(['settings', 'user']),
    pageUrl() {
      const { userId } = store.state.user.user;
      return Constants.APP_URL + `/invite/${userId}?md=1`;
    },
    churchLogo() {
      return this.selectedLogo || (this.user.user.invite_video && this.user.user.invite_video.church_logo_moderator);
    },
    videoFile() {
      return this.selectedVideo || (this.user.user.invite_video && this.user.user.invite_video.church_video_moderator);
    },
  },
  mounted() {
    this.selectedVideo = this.$router.currentRoute.params.captured;
    if (this.selectedVideo) {
      this.isVideoCaptured = true;
    } else if (this.videoFile) {
      setTimeout(() => {
        window.jwplayer('previewSelectedVideo').setup({
          file: this.videoFile,
          primary: 'flash',
          type: 'mp4',
          autostart: false,
          repeat: false,
        });
      });
    }

    if (this.videoFile) {
      this.originPageVisible = false;
    }
  },
  methods: {
    videoFileUrl(blob) {
      return URL.createObjectURL(blob);
    },
    clipboardSuccess() {
      this.$notification['success']({
        message: 'Copied to clipboard',
      });
    },
    async imageSelectChange() {
      const img = this.$refs.imagePicker.files[0];
      if (!img) {
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(img);
      reader.onload = e => {
        this.selectedLogo = e.target.result;
        this.originPageVisible = false;
      };
    },
    captureVideo() {
      this.selectedVideo = null;
      this.$router.push({ name: 'captureVideo', query: { redirectTo: 'churchInviteModerator' } });
    },
    async videoSelectChange() {
      const video = this.$refs.videoPicker.files[0];
      if (!video) {
        return;
      }

      this.isVideoCaptured = false;
      this.selectedVideo = video;
      this.originPageVisible = false;

      setTimeout(() => {
        window.jwplayer('previewSelectedVideo').setup({
          file: URL.createObjectURL(this.selectedVideo),
          primary: 'flash',
          type: 'mp4',
          autostart: false,
          repeat: false,
        });
      });
    },
    async saveVideo() {
      const { accountId } = this.user.user;

      if (!accountId || !this.selectedVideo) {
        return;
      }

      try {
        const videoResp = await new Uploader().uploadVideoFile(this.selectedVideo, percent => (this.progress = percent));

        // update church info even it is not an administrator
        await AdminService.account.update(accountId, {
          church_video_moderator: videoResp.Location,
        });

        this.$notification['success']({
          message: 'Uploaded successfully',
          description: 'Your moderator invitation video has been uploaded successfully!',
        });
      } catch (err) {
        this.$notification['error']({
          message: err.message || this.$t('label.somethingWentWrong'),
        });

        console.log(err);
      } finally {
        this.progress = -1;
      }
    },
    async removeVideo() {
      if (this.selectedVideo) {
        this.selectedVideo = null;
      }

      const { accountId, invite_video } = this.user.user;

      if (!accountId || !invite_video || !invite_video.church_video_moderator) {
        return;
      }

      try {
        this.progress = 0;

        // update church info even it is not an administrator
        await AdminService.account.update(accountId, {
          church_video_moderator: null,
        });

        this.$notification['success']({
          message: 'Removed successfully',
          description: 'Your church moderator invitation video has been removed successfully!',
        });
        invite_video['church_video_moderator'] = null;

        this.$store.dispatch('updateUser', {
          user: {
            ...this.user.user,
            invite_video: invite_video,
          },
        });
      } catch (err) {
        this.$notification['error']({
          message: err.message || this.$t('label.somethingWentWrong'),
        });

        console.log(err);
      } finally {
        this.progress = -1;
      }
    },
    async saveImage() {
      const { accountId } = this.user.user;

      if (!accountId) {
        return;
      }

      try {
        this.progress = 0;
        const imageResp = await this.uploadImage(this.selectedLogo);

        // update church info even it is not an administrator
        await AdminService.account.update(accountId, {
          church_logo_moderator: imageResp.Location,
        });

        this.$notification['success']({
          message: 'Uploaded successfully',
          description: 'Your church moderator invitation logo has been uploaded successfully!',
        });
      } catch (err) {
        this.$notification['error']({
          message: err.message || this.$t('label.somethingWentWrong'),
        });

        console.log(err);
      } finally {
        this.progress = -1;
      }
    },
    async removeImage() {
      const { accountId, invite_video } = this.user.user;

      if (!accountId || !invite_video) {
        return;
      }

      if (this.selectedLogo) {
        this.selectedLogo = null;
      }

      if (!invite_video.church_logo_moderator) {
        return;
      }

      try {
        this.progress = 0;

        // update church info even it is not an administrator
        await AdminService.account.update(accountId, {
          church_logo_moderator: null,
        });

        this.$notification['success']({
          message: 'Removed successfully',
          description: 'Your church moderator invitation logo has been removed successfully!',
        });
        invite_video['church_logo_moderator'] = null;

        this.$store.dispatch('updateUser', {
          user: {
            ...this.user.user,
            invite_video: invite_video,
          },
        });
      } catch (err) {
        this.$notification['error']({
          message: err.message || this.$t('label.somethingWentWrong'),
        });

        console.log(err);
      } finally {
        this.progress = -1;
      }
    },
    uploadImage(image) {
      return new Uploader().uploadImage(
        {
          contentType: 'image/png',
          fileName: `img_${Date.now()}.png`,
          file: image,
        },
        percent => (this.progress = percent),
      );
    },
  },
};
</script>
<style lang="scss">
.setup-share-story-container.content-page {
  padding: 0 !important;
  .setup-share-story {
    padding: 20px;
    .ant-btn {
      // height: 100%;
      white-space: initial;
    }
    .link-label {
      white-space: nowrap;
      flex: 0 0 auto;
      font-weight: 600;
      margin-right: 16px !important;
    }
    .link-value {
      margin-left: 8px;
      flex: 0 1 auto;
      word-break: break-all;

      & > a {
        color: #212b36;
        text-decoration: underline;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.font-helvetica {
  line-height: 1.2;
  font-size: 28px !important;
}
.clipboard-btn {
  line-height: 24px !important;
  height: 24px !important;
  width: 24px !important;
  padding: 0 !important;
  margin-left: 16px !important;
  border-radius: 5px !important;
}

.upload-wrapper {
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.image-uploader {
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  margin: 80px auto;
  max-width: 240px;
}

.church-logo img {
  max-height: 25vw !important;
  object-fit: contain;
}

/deep/ .ant-spin-nested-loading > div > .ant-spin {
  position: fixed !important;
  top: calc(50vh - 40px);
  height: auto;
}

@media (min-width: 768px) {
  /deep/ .unfixed .ant-spin {
    transform: translateX(120px);
  }
  /deep/ .toggled .ant-spin {
    transform: translateX(36px);
  }
}
</style>
